const NotFound = () => import("../components/NotFound.vue");
export default [
  {
    name: "notFound",
    path: "/:catchAll(.*)*",
    meta: {
      Title: "NotFound",
      layout: "LoggedLayout",
      requireAuth: true,
    },
    component: NotFound,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem("access_token");
      let roles = "";
      let clientName = "";
      let isAdmin = false;
      let isSupport = false;
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split(".")[1]));
          roles = String(payload.extension_Roles || "").toLowerCase();
          clientName = (payload.extension_ClientName || "").toLowerCase();
          isAdmin = roles.includes("admin");
          isSupport = roles.includes("support");
        } catch (e) {
          console.error("Error decoding token in NotFound route:", e);
        }
      }
      const isQA = roles.includes("qa") || roles.includes("quality_assurance");
      const selectedClientCode = localStorage.getItem("selectedClientCode");
      const isAuceraUser = clientName === "aucera";

      if (isQA) {
        next(); // QA sees page not found
      } else if (
        isAuceraUser &&
        (isAdmin || isSupport) &&
        !selectedClientCode
      ) {
        next("/client-selector"); // Admin/Support without client selected goes here before their targeted url
      } else {
        next("/home"); // Everyone else goes to the home page
      }
    },
  },
];